import { z } from "zod";

import {
  CreateExclusionGroupDtoSchema,
  ExclusionGroupDtoSchema,
} from "../../../dtos/exclusion-group";

export const PostExclusionGroupRequestBodySchema = z.object({
  experienceId: z.string().uuid(),
  exclusionGroup: CreateExclusionGroupDtoSchema,
});
export type PostExclusionGroupRequestBodyType = z.infer<
  typeof PostExclusionGroupRequestBodySchema
>;

export const PostExclusionGroupResponseBodySchema = z.object({
  exclusionGroup: ExclusionGroupDtoSchema,
});
export type PostExclusionGroupResponseBodyType = z.infer<
  typeof PostExclusionGroupResponseBodySchema
>;
